import React from "react";
import { Box, Text, HStack, Icon, Link as ChakraLink } from "@chakra-ui/react";
import { FaInstagram, FaFacebook } from "react-icons/fa"; // Import icons for social media
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="orange.500" // Footer background color
      color="white" // Text color
      py={4} // Padding on y-axis (top and bottom)
      mt={0} // Margin on top to create space from content above
      textAlign="center" // Center text
    >
      <Text fontSize="sm" mb={2}>
        &copy; {new Date().getFullYear()} ATO. All rights reserved.{" "}
        <Link to="/disclaimer" style={{ display: "inline" }}>
          <Text
            as="span"
            fontSize="xs"
            _hover={{ textDecoration: "underline" }}
            cursor="pointer"
          >
            | Disclaimer
          </Text>
        </Link>
      </Text>

      <HStack spacing={4} justify="center">
        <ChakraLink href="https://www.instagram.com" isExternal>
          <Icon as={FaInstagram} boxSize={6} _hover={{ color: "orange.200" }} />
        </ChakraLink>
        <ChakraLink href="https://www.facebook.com" isExternal>
          <Icon as={FaFacebook} boxSize={6} _hover={{ color: "orange.200" }} />
        </ChakraLink>
      </HStack>
    </Box>
  );
};

export default Footer;
